import { render } from "./RegisterPopup.vue?vue&type=template&id=3c35153f&scoped=true"
import script from "./RegisterPopup.vue?vue&type=script&lang=js"
export * from "./RegisterPopup.vue?vue&type=script&lang=js"

import "./RegisterPopup.vue?vue&type=style&index=0&id=3c35153f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3c35153f"

export default script